function getStoreLocation(store: Record<string, any>) {
  return {
    lat: parseFloat(store.address?.coordinates?.latitude),
    lng: parseFloat(store.address?.coordinates?.longitude),
  }
}

export default getStoreLocation
